import React, { Fragment, useEffect, useState, useRef } from "react";
import { Nav, NavDropdown, Form, FormControl } from "react-bootstrap";
import { FiLogOut } from "react-icons/fi";
import { useTranslation } from 'react-i18next';
import FeatureBasedSearch from '../../components/Search/Search'
import Cookies from 'universal-cookie';
import { loopBackDomain, loopBackPort } from "environment/environment";
import { withRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PostAPI } from "api/post";

let user = require('../../assets/img/faces/face-0.jpg');
const cookies = new Cookies();

const AdminNavbarLinks  = props => {
  const dropdownRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(prevState => !prevState);
  };

  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',

    }
  ]

    const notification = (
      <div>
        {/* <i className="fa fa-globe" />
        <b className="caret" />
        <span className="notification">0</span>
        <p className="hidden-lg hidden-md">Notification</p> */}
      </div>
    );


  const { t, i18n } = useTranslation();
  const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english';
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);

  async function  handleLanguageChange(language) {
      localStorage.setItem('i18nextLng', language);
      i18n.changeLanguage(language)
      const payload = {
        language: currentLanguageCode === 'en' ? 'english' : 'chinese'
      };
      let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/yml';
      let responseData = await PostAPI(url,payload);
      let responseDataJson = JSON.parse(responseData.data.data)
      localStorage.setItem('chineseSidebar', JSON.stringify(responseDataJson));
    }
  

  useEffect(()=>{
      let currentLang = localStorage.getItem('i18nextLng')
      i18n.changeLanguage(currentLang)
    },[])

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const logout = () => {
    const param = cookies.get('title');
    document.title = param?.split('-')[0];
      cookies.remove('accessToken',{ path: '/' });
      cookies.remove('user_id',{ path: '/' });
      cookies.remove('userLocation_id',{ path: '/' });
      cookies.remove('userRole_name',{ path: '/' });
      cookies.remove('feature_id',{ path: '/' });
      cookies.remove('pagetype_id',{ path: '/' });
      cookies.remove('customer_type',{ path: '/' });
      cookies.remove('customer_id',{ path: '/' });
      cookies.remove('tabTitle',{ path: '/' });
      cookies.remove('title', {path: '/'});
      localStorage.removeItem('i18nextLng');
      localStorage.removeItem("newSidebar");
      localStorage.removeItem('redirectPath');


      // if(localStorage.getItem('rememberMe')==null ||localStorage.getItem('rememberMe')=="false"){
      //   localStorage.removeItem('cookieCheck')
      //   }
              localStorage.removeItem('i18nextLng');
      setTimeout(function(){
        // window.location.href = "/login";
        props.history.push('/login');
      },0)    
  }

  return (
    <div className="navbar-container">
      <Nav>
        <div>
          <FeatureBasedSearch 
          onNavigate={() => props.onNavigate('search')}
          navigation={props.navigation}
            />
        </div>
        {/* <Form inline className="mx-auto">
          <i className="search fa fa-search" aria-hidden="true"></i>
          <FormControl type="text" placeholder="Search or type" className="mr-sm-2" />
        </Form> */}
      </Nav>
      <Nav pullRight>
        <NavDropdown
          open={isDropdownOpen} // Use 'show' instead of 'open'
          noCaret
          title={
            <img
              src={user}
              alt="Profile"
              className="profile-thumbnail"
              onClick={toggleDropdown}
              style={{ cursor: "pointer" }}
            />
          }
          className="nav-dropdownOptions"
        >
          <div ref={dropdownRef}>
            {!localStorage.getItem('email') ? (
              <li className="clickable" onClick={logout}>
                Logout
                <span className="logout-icon">
                  <FiLogOut />
                </span>
              </li>
            ) : (
              <>
              <li>
                <span className="email-content">{localStorage.getItem('email')}</span>
              </li>
              <hr className='nav-dropdown_partition'></hr>
            <li className="clickable" onClick={logout}>
              Logout
              <span className="logout-icon">
                <FiLogOut />
              </span>
            </li>
            </>
            )}  
          </div>
        </NavDropdown>
      </Nav>
    </div>
  );
}


export default withRouter(AdminNavbarLinks);
